import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    :root {
        --blue: #273782;
        --blue2: #3F66FB;
        --yellow: #FFC510;
        --lead: #545E75;
        --ice: #F4F5F8;
        --green: #44B827;

        --dark: #030303;
        --grey1: #3A393D;
        --grey2: #55555F;
        --grey3: #63626A;
        --grey4: #7E7E7E;
        --grey5: #3D3D3D;
        --grey6: #D9D9D9;
        --grey7: #AFAFAF;
        --grey8: #858585;
        --grey9: #424242;
        --light: #E2E0E5;
        --darker: #000000;
        --lighter: #FFFFFF;

        --hPadding: 15rem;
        --shadow-soft: 0 10px 30px rgba(0, 0, 0, 0.08);
        --shadow-medium: 0 15px 45px rgba(0, 0, 0, 0.12);
        --radius-sm: 8px;
        --radius-md: 12px;
        --radius-lg: 20px;
        --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        @media only screen and (min-width: 2300px) {
            --hPadding: 20rem;
        }

        @media only screen and (max-width: 1600px) {
            --hPadding: 10rem;
        }

        @media only screen and (max-width: 1400px) {
            --hPadding: 5rem;
        }

        @media only screen and (max-width: 1200px) {
            --hPadding: 3rem;
        }

        @media only screen and (max-width: 768px) {
            --hPadding: 1.5rem;
        }

        @media only screen and (max-width: 480px) {
            --hPadding: 1rem;
        }
    }

    body {
        margin: 0;
        padding: 0;
    }

    a {
        text-decoration: none;
    }

    button {
        border: 0;
        cursor: pointer;
    }

    input, textarea, select {
        width: 100%;
        box-sizing: border-box;
        border: 1.5px solid var(--grey6);
        border-radius: var(--radius-sm);
        font-size: 16px;
        padding: 0.85rem;
        transition: var(--transition);
        background: var(--lighter);
        
        &:focus {
            outline: none;
            border-color: var(--blue2);
            box-shadow: 0 0 0 4px rgba(63, 102, 251, 0.1);
        }
    }

    ::-webkit-input-placeholder, :-moz-placeholder, ::-moz-placeholder, :-ms-input-placeholder, ::placeholder {
        color: var(--grey7);
    }

    h1, h2, h3, h4, a {
        margin: 0;
        font-family: 'Raleway', Sans-Serif;
        color: var(--dark);
    }

    h1, h2 {
        font-weight: 600;
    }

    h3, h4 {
        font-weight: 500;
    }

    h1 {
        font-size: 48px;
        line-height: 56.35px;
    }

    h2 {
        font-size: 40px;
        line-height: 46.96px;
    }

    h3 {
        font-size: 32px;
        line-height: 37.57px;
    }

    h4 {
        font-size: 24px;
        line-height: 28.18px;
    }

    p, span, label, button, input, textarea {
        margin: 0;
        font-family: 'Be Vietnam Pro', Sans-Serif;
    }

    .h-padded {
        padding-left: var(--hPadding);
        padding-right: var(--hPadding);
    }

    .v-padded {
        padding-top: 5rem;
        padding-bottom: 5rem;

        @media only screen and (max-width: 768px) {
            padding-top: 3rem;
            padding-bottom: 3rem;
        }
    }

    .main {
        position: relative;
        top: 106px;

        @media only screen and (max-width: 300px) {
            top: 79px;
        }
    }

    .flexbox {
        display: flex;

        &.block-on-mobile {
            @media only screen and (max-width: 1050px) {
                display: block;
            }
        }
    }

    .h-spaced-between {
        justify-content: space-between;
    }

    .h-centered {
        justify-content: center;
    }

    .v-centered {
        align-items: center;
    }

    .btn {
        display: block;
        font-family: "Be Vietnam Pro", sans-serif;
        font-size: 18px;
        font-weight: 600;
        width: fit-content;
        border-radius: var(--radius-md);
        padding: 0.75rem 3.5rem;
        text-align: center;
        transition: var(--transition);
        letter-spacing: 0.5px;

        &.not-block {
            display: initial;
        }

        &.square {
            border-radius: var(--radius-sm);
        }

        &.sm {
            padding: 0.75rem 1.5rem;
        }

        &.yellow {
            background: var(--yellow);
            color: var(--grey1);
            box-shadow: 0 4px 15px rgba(255, 197, 16, 0.3);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 25px rgba(255, 197, 16, 0.4);
            }

            &:active {
                transform: translateY(0);
            }
        }

        &.blue {
            background: var(--blue);
            color: var(--lighter);
            box-shadow: 0 4px 15px rgba(39, 55, 130, 0.3);

            &:hover {
                background: var(--blue2);
                color: var(--lighter);
                transform: translateY(-2px);
                box-shadow: 0 8px 25px rgba(63, 102, 251, 0.4);
            }

            &:active {
                transform: translateY(0);
            }
        }

        &.white {
            background: var(--lighter);
            border: 1.5px solid var(--blue);
            color: var(--blue);

            &:hover {
                background: var(--blue);
                color: var(--lighter);
                transform: translateY(-2px);
                box-shadow: var(--shadow-soft);
            }
        }
    }

    .premium-arrows {
        .splide__arrow {
            width: 50px;
            height: 50px;
            background: rgba(255, 255, 255, 0.4);
            backdrop-filter: blur(8px);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            color: var(--blue);
            opacity: 1;
            transition: all 0.3s ease;
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);

            @media only screen and (max-width: 768px) {
                width: 36px;
                height: 36px;
            }

            &:hover {
                background: var(--blue);
                color: var(--lighter);
                transform: scale(1.1) translateY(-50%);
                
                &:disabled {
                    opacity: 0.5;
                }
            }

            svg {
                display: none;
            }

            .material-symbols-rounded {
                font-size: 24px;
                @media only screen and (max-width: 768px) {
                    font-size: 18px;
                }
            }

            &--prev {
                left: 2rem;
                @media only screen and (max-width: 768px) {
                    left: 0.5rem;
                }
            }

            &--next {
                right: 2rem;
                @media only screen and (max-width: 768px) {
                    right: 0.5rem;
                }
            }
        }
    }

    .premium-pagination {
        bottom: 2rem !important;
        padding: 0 4rem;
        gap: 1rem;

        @media only screen and (max-width: 768px) {
            bottom: 0.75rem !important;
            padding: 0 1rem;
            gap: 0.5rem;
        }

        .premium-page {
            width: 60px;
            height: 4px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 2px;
            transition: all 0.4s ease;
            margin: 0;

            @media only screen and (max-width: 768px) {
                width: 30px;
            }

            &.is-active {
                width: 100px;
                background: var(--blue);
                transform: none;

                @media only screen and (max-width: 768px) {
                    width: 50px;
                }
            }
        }
    }

    .swal2-container {
        font-family: 'Raleway', Sans-Serif;
    }
`;

export default GlobalStyle;
